import React from 'react'

import './WorkingStepForm.scss'
import { JsonSchema } from 'services/APIs/InternalAPI/internal-api.contracts'

import Form from '@rjsf/material-ui'
import { RJSFQuantityField } from './JsonSchemaWrappers/RJSFQuantityField'
import { RJSFSameLineFieldTemplate } from './JsonSchemaWrappers/RJSFSameLineFieldTemplate'
import { ArrayFieldTemplate } from './JsonSchemaWrappers/ArrayFieldTemplate'
import { SelectInput } from './JsonSchemaWrappers/SelectInput'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { Box, Button } from '@material-ui/core'
import { AddOutlined, CheckOutlined } from '@material-ui/icons'
import { AjvError } from '@rjsf/core'
import { FormDataDto } from 'model/FormDataDto'
import { AdditionalWorkingStepFormConfiguration } from 'model/AdditionalWorkingStep/AdditionalWorkingStepForm'
import { JsonViewer } from 'components/Common/Json'
// import { JsonViewer } from 'components/Common/Json'

type Props = {
  workingStepForm: AdditionalWorkingStepFormConfiguration
  saveWorkingStepForm: (
    formDataDto: FormDataDto,
    isEditing: boolean
  ) => Promise<void>
  isSaving?: boolean
  editing: boolean
  workingStepName: string
  setValidationError: (e: AjvError[]) => void
  extraErrors?
}

const EmptyComponent = (props: {
  isEmpty: boolean
  editing: boolean
  workingStepName: string
}) => {
  if (!props.isEmpty) return null

  if (props.editing) {
    return (
      <Box display="flex" alignItems="center">
        <CheckOutlined color="action" />
        <LocalizedTypography
          translationKey={'project:working-steps-included'}
        />
      </Box>
    )
  } else {
    return (
      <Button type="submit">
        <AddOutlined color="action" />
        <span>{`include ${props.workingStepName}`}</span>
      </Button>
    )
  }
}

export const WorkingStepForm = (props: Props) => {
  let isEmpty = false

  const uiSchema: JsonSchema & { 'ui:title': string } = {
    ...props.workingStepForm.uiSchema,
    'ui:title': props.workingStepName,
  }

  if (props.workingStepForm.jsonSchema?.title === 'EmptyDto') {
    isEmpty = true
  }

  return (
    <div className="working-step-form">
      {props.workingStepForm && (
        <Form
          // liveValidate
          formContext={{ onValidationError: props.setValidationError }}
          schema={props.workingStepForm.jsonSchema}
          uiSchema={uiSchema}
          formData={props.workingStepForm.formData}
          showErrorList={false}
          fields={{
            quantityField: RJSFQuantityField,
          }}
          ObjectFieldTemplate={RJSFSameLineFieldTemplate}
          ArrayFieldTemplate={ArrayFieldTemplate}
          widgets={{
            SelectWidget: SelectInput,
          }}
          onSubmit={(e) => {
            props.saveWorkingStepForm(e.formData, props.editing)
          }}
          onChange={(e) => {
            props.saveWorkingStepForm(e.formData, props.editing)
          }}
        >
          <div className={`form-actions ${isEmpty ? 'empty' : ''}`}>
            {
              <EmptyComponent
                isEmpty={isEmpty}
                editing={props.editing}
                workingStepName={props.workingStepName}
              />
            }
          </div>
        </Form>
      )}
      {
        process.env.NODE_ENV === 'development' ? (
          <JsonViewer data={props.workingStepForm} />
        ) : null
      }
    </div>
  )
}
